import { DASHBOARD_BASE_ROUTE } from '@Constants/routes';
import { Breadcrumbs, Link } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { BreadcrumbContext } from '../Layout';

const HeaderBreadcrumbs = () => {
	const { pathname } = useLocation();
	const history = useHistory();
	const { extraLink } = useContext(BreadcrumbContext);

	const isContent = pathname.startsWith('/dashboard/classrooms');
	const isClassroom = pathname.includes('/dashboard/classrooms/classroom/');
	const isStandalone = pathname.includes(
		'/dashboard/classrooms/standalone-courses'
	);
	const breadcrumbOrder = [
		'classroom',
		'standalone-course',
		'course',
		'lecture',
		'add-lecture',
	];
	const orderedExtraLinks = [...extraLink].sort(
		(a, b) =>
			breadcrumbOrder.indexOf(a.routeHash) -
			breadcrumbOrder.indexOf(b.routeHash)
	);

	return (
		<Breadcrumbs maxItems={8}>
			<StyledLink onClick={() => history.push(`/dashboard`)} color="inherit">
				Home
			</StyledLink>
			{isContent && (
				<StyledLink
					onClick={() => history.push('/dashboard/classrooms')}
					color="inherit"
				>
					Content
				</StyledLink>
			)}
			{isClassroom && (
				<StyledLink
					onClick={() => history.push('/dashboard/classrooms')}
					color="inherit"
				>
					Classrooms
				</StyledLink>
			)}
			{isStandalone && (
				<StyledLink
					style={{ textTransform: 'none' }}
					onClick={() =>
						history.push('/dashboard/classrooms/standalone-courses')
					}
					color="inherit"
				>
					standalone-courses
				</StyledLink>
			)}
			{!isContent &&
				pathname
					.split('/')
					.filter((_) => `/${_}` !== DASHBOARD_BASE_ROUTE)
					.filter((_) => _ !== '')
					.slice(0, 1)
					.map((_, index) => (
						<StyledLink
							key={`${index}-${_}-bc`}
							onClick={() => history.push(`${DASHBOARD_BASE_ROUTE}/${_}`)}
							color="inherit"
						>
							{_.replace('-', ' ')}
						</StyledLink>
					))}
			{orderedExtraLinks.map((_, index) => {
				return (
					<StyledLink
						key={`${index}-${_.routeHash}`}
						onClick={() => {
							if (!pathname.endsWith(_.route)) history.push(`${_.route}`);
						}}
						color="inherit"
					>
						{_.title}
					</StyledLink>
				);
			})}
		</Breadcrumbs>
	);
};

export default HeaderBreadcrumbs;

const StyledLink = styled(Link)`
	text-transform: capitalize;
	cursor: pointer;
`;
